;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      async_data: null,
      async_dates: null,
      merchant_id: null,
      current_user_id: null
    };
  },
  created: function created() {
    this.merchant_id = this.$attrs["merchant_id"];
    this.current_user_id = this.$attrs["user_id"];
    this.get_revenue_data();
  },

  computed: {
    chartOptions: function chartOptions() {
      return {
        reflow: true,
        chart: {
          type: "areaspline"
        },
        title: {
          text: ""
        },
        xAxis: {
          gridLineWidth: 1,
          title: {
            text: "Day"
          },
          categories: this.async_dates
        },
        yAxis: {
          gridLineWidth: 1,
          title: {
            text: "No of customers"
          }
        },
        series: [(0, _defineProperty3.default)({
          lineWidth: 2,
          color: "#3C009B",
          name: "Customers Served",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(176,145,226)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: this.async_data
        }, "color", "#6fcd98")]
      };
    }
  },
  methods: {
    get_revenue_data: function get_revenue_data() {
      var _this = this;

      var url = "/api/dashboard/agency/customers/graph";
      Vue.axios.get(url, {
        params: { owner_id: this.merchant_id, user_id: this.current_user_id }
      }).then(function (response) {
        var vdata = (0, _stringify2.default)(response.data);
        var data = JSON.parse(vdata);
        data = data.sort(function (d1, d2) {
          var m1 = (0, _moment2.default)(d1.date);
          var m2 = (0, _moment2.default)(d2.date);
          if (m1.isBefore(m2)) return -1;
          if (m1.isSame(m2)) return 0;
          if (m1.isAfter(m2)) return 1;
        });
        _this.async_dates = data.map(function (d) {
          return (0, _moment2.default)(d.date).format("ddd Do MMM");
        });
        _this.async_data = data.map(function (d) {
          return parseFloat(d.customers_total);
        });
      }).catch(function (error) {}).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{attrs:{"options":_vm.chartOptions}})}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-7a4a4b87"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a4a4b87", __vue__options__)
  } else {
    hotAPI.reload("data-v-7a4a4b87", __vue__options__)
  }
})()}